// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-3dJ0","colMin":"styles_colMin__11AdK"};